// React
import React from 'react';
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  Form,
  Input,
  Label,
  Row,
} from 'reactstrap';

// Containers Injection
import {
  convertEventSelectToTarget,
  PageWrapper,
  SelectInput,
} from '../../containers/componentsInjection';

export const ProposalsByOrganizationPage = ({
  history,
  createData,
  validation,
  organizations,
  statusOptions,
  dataReportType,
  dataCadastralStatus,
}) => {
  return (
    <PageWrapper title="Propostas por Organização">
      <Row>
        <Col xxl={12}>
          <Card>
            <Form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <CardBody className="p-4">
                <Row>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label className="form-label">Período por</Label>
                      <div className="d-flex justify-content-between align-items-center">
                        <Col>
                          <Input
                            id="periodTypeSale"
                            name="periodType"
                            className="me-2"
                            type="radio"
                            value={'sale'}
                            onBlur={validation.handleBlur}
                            checked={validation.values.periodType === 'sale'}
                            onChange={(e) => {
                              if (e.target.value === 'sale') {
                                validation.handleChange({
                                  target: {
                                    name: 'periodType',
                                    value: 'sale',
                                  },
                                });
                              }
                            }}
                          />
                          <Label
                            htmlFor="periodTypeSale"
                            className="text-muted text-uppercase"
                          >
                            Data da Venda
                          </Label>
                        </Col>

                        <Col>
                          <Input
                            id="periodTypeCreated"
                            name="periodType"
                            className="me-2"
                            type="radio"
                            value={'created'}
                            onBlur={validation.handleBlur}
                            checked={validation.values.periodType === 'created'}
                            onChange={(e) => {
                              if (e.target.value === 'created') {
                                validation.handleChange({
                                  target: {
                                    name: 'periodType',
                                    value: 'created',
                                  },
                                });
                              }
                            }}
                          />
                          <Label
                            htmlFor="periodTypeCreated"
                            className="text-muted text-uppercase"
                          >
                            Data da Vigência
                          </Label>
                        </Col>
                      </div>
                    </div>
                  </Col>

                  <Col md={4} className="mb-3">
                    <div>
                      <Label for="saleAtInput" className="form-label">
                        Período
                      </Label>
                      <div className="d-flex justify-content-center align-items-center">
                        <Input
                          type="date"
                          id="periodStarts"
                          value={validation.values.periodStarts}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                        />

                        <span className="m-2">a</span>

                        <Input
                          type="date"
                          id="periodEnds"
                          value={validation.values.periodEnds}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                        />
                      </div>
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="organizationInput">
                        Organização
                      </Label>
                      <SelectInput
                        multiple
                        inputId="organizationInput"
                        value={validation.values.organizationInput}
                        className="form-control"
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'organizationInput',
                              eventInput
                            )
                          );
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'organizationInput',
                              eventInput
                            )
                          );
                        }}
                        options={createData(organizations)}
                        placeholder="Todas"
                      />
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="reportType">
                        Tipo de Relatório
                      </Label>
                      <SelectInput
                        isClearable
                        inputId="reportType"
                        value={validation.values.reportType}
                        className="form-control"
                        onChange={(eventInput) => {
                          if (!eventInput) {
                            validation.handleChange({
                              target: {
                                name: 'reportType',
                                value: {
                                  label: '',
                                  value: '',
                                },
                              },
                            });
                          } else {
                            validation.handleChange(
                              convertEventSelectToTarget(
                                'reportType',
                                eventInput
                              )
                            );
                          }
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget('reportType', eventInput)
                          );
                        }}
                        options={dataReportType}
                        placeholder="Selecione o tipo de relatório"
                      />
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="mb-3">
                      <Label
                        htmlFor="employeeSituationInput"
                        className="form-label"
                      >
                        Situação Cadastral
                      </Label>
                      <SelectInput
                        multiple
                        className="form-control"
                        inputId="employeeSituationInput"
                        value={validation.values.employeeSituationInput}
                        onChange={(eventInput) => {
                          if (!eventInput.length) {
                            validation.handleChange(
                              convertEventSelectToTarget(
                                'employeeSituationInput',
                                null
                              )
                            );
                          } else {
                            validation.handleChange(
                              convertEventSelectToTarget(
                                'employeeSituationInput',
                                eventInput
                              )
                            );
                          }
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'employeeSituationInput',
                              eventInput
                            )
                          );
                        }}
                        options={dataCadastralStatus}
                        placeholder="Selecione a situação cadastral"
                        invalid={
                          !!(
                            validation.touched.employeeSituationInput &&
                            validation.errors.employeeSituationInput
                          )
                        }
                      />
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="mb-3">
                      <Label
                        htmlFor="proposalSituationInput"
                        className="form-label"
                      >
                        Situação da Proposta
                      </Label>
                      <SelectInput
                        multiple
                        className="form-control"
                        inputId="proposalSituationInput"
                        value={validation.values.proposalSituationInput}
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'proposalSituationInput',
                              eventInput
                            )
                          );
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'proposalSituationInput',
                              eventInput
                            )
                          );
                        }}
                        options={statusOptions}
                        placeholder="Todos"
                      />
                    </div>
                  </Col>

                  <Col md={12}>
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="notes">
                        Notas
                      </Label>
                      <Input
                        id="notes"
                        aria-multiline
                        type="textarea"
                        className="form-control"
                        onBlur={validation.handleBlur}
                        onChange={validation.handleChange}
                        value={validation.values.notes}
                        style={{
                          height: 100,
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </CardBody>

              <CardFooter>
                <Col md={12}>
                  <div className="text-end d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-link me-3"
                      onClick={() => {
                        history.push('/relatorios');
                      }}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Gerar Relatório
                    </button>
                  </div>
                </Col>
              </CardFooter>
            </Form>
          </Card>
        </Col>
      </Row>
    </PageWrapper>
  );
};
